export default {
    audio: "Please, check access to your microphone under settings",
    video: "Please, check access to your camera under settings",
    audio_video: "Please, check access to your camera and microphone under settings"
}
